// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__NdzEX","title":"AfterBackImages_title__337Rw","images":"AfterBackImages_images__GwXsh"};